// src/refs.ts
var assignRef = (ref, value) => {
  if (ref === null || ref === void 0)
    return;
  if (typeof ref === "function") {
    ref(value);
    return;
  }
  ref.current = value;
};
var combineRefs = (...refs) => {
  return (node) => {
    refs.forEach((ref) => {
      assignRef(ref, node);
    });
  };
};

// src/debounce.ts
import { useEffect, useState } from "react";
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay || 500);
    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);
  return debouncedValue;
}
export {
  combineRefs,
  useDebounce
};
